import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";
import TASPositivePayCreateTemplateFileMappingPreviewTable from "./components/TASPositivePayCreateTemplateFileMappingPreviewTable";

import { SecondaryButton } from "components/ui";
import TASPositivePayCreateTemplateFileMappingPreviewMobileTable from "./components/TASPositivePayCreateTemplateFileMappingPreviewMobileTable";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayCreateTemplateFileMappingPreviewWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Mapping Preview widget for the ImportFileNewTemplatePage.
 */
export default function TASPositivePayCreateTemplateFileMappingPreviewWidget(props) {
    const { ui, data } = useStateManager();
    const fileRows = data.checkTemplateRows.length;
    const showFilePreview = ui.checkTemplate.showFilePreview;

    return (
        <div className="tas-positive-pay-create-template-file-mapping-preview-widget">
            <h2>
                <span data-point={ `TAS_Positive_Pay_Create_Template_File_Mapping_Preview_Widget_Title` }>Mapping Preview</span>
            </h2>
            { !showFilePreview.isActive && <p>{ `No file chosen. Preview will be displayed when file is uploaded.`}</p> }
            { showFilePreview.isActive && <p>Preview showing all rows ({ fileRows }).</p> }

            <div className="show-on-desktop">
                <TASPositivePayCreateTemplateFileMappingPreviewTable />
            </div>
            <div className="show-on-mobile">
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTable />
                <DisabledPrompt>
                    <SecondaryButton className="show-more-button set-width"  text="Show More" />
                </DisabledPrompt>
            </div>
        </div>
    )
}
